import { argmax, entropyRatio } from "./math.js";

export function interpret(probs, metadata) {
  const classes = metadata.classes;
  const index = argmax(probs);
  const { min_confidence: minConfidence = 0.45, max_entropy_ratio: maxEntropy = 0.85 } = metadata.uncertainty || {};
  const confidence = probs[index];
  const entropy = entropyRatio(probs);
  const ranking = classes
    .map((spec, i) => ({ ...spec, probability: probs[i] }))
    .sort((a, b) => b.probability - a.probability);
  return {
    top: ranking[0],
    ranking,
    confidence,
    entropy,
    uncertain: confidence < minConfidence || entropy > maxEntropy,
    probabilities: Object.fromEntries(classes.map((spec, i) => [spec.id, Number(probs[i].toFixed(4))]))
  };
}
